import React from "react";
import RegisterAuth from '../components/auth/Register';

function Register(props) {
  return (
    <RegisterAuth  />
  );
}
export default Register;
